import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Root layout component
 * Wraps all routes with common layout elements
 */
const RootLayout = () => {
  return (
    <div className="min-h-screen bg-background">
      <Suspense
        fallback={
          <div className="flex h-screen items-center justify-center">
            <div className="text-lg">Loading...</div>
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </div>
  );
};

export default RootLayout;
